import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../../styles/PackagesCatalog.css';

const PackageImageRow = ({ images }) => {
  const navigate = useNavigate();

  return (
    <div className="package-image-row">
      {images.map((image, index) => (
        <div 
          key={index}
          className="package-image-container"
          onClick={() => navigate(image.link)}
        >
          <img 
            src={image.path} 
            alt={image.title}
            className="package-image"
          />
          {/* <div className="package-image-title">{image.title}</div> */}
        </div>
      ))}
    </div>
  );
};

export default PackageImageRow;
